// extracted by mini-css-extract-plugin
module.exports = {"properties":"ComparativeRows_properties__1BJbN","comparative-container":"ComparativeRows_comparative-container__3X0mT"};